import getAssetUrl from '@/lib/assetUrl';

import { Favicon } from '@/customTypes/favicon';

// !STARTERCONF this is the default favicon, you can generate your own from https://www.favicon-generator.org/ then replace the whole /public/favicon folder
export const favicons: Array<Favicon> = [
  {
    rel: 'shortcut icon',
    href: `${getAssetUrl('favicon/favicon.ico')}`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: `${getAssetUrl('favicon/apple-touch-icon-180x180.png')}`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '192x192',
    href: `${getAssetUrl('favicon/android-icon-192x192.png')}`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '192x192',
    href: `${getAssetUrl('favicon/android-chrome-icon-512x512.png')}`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: `${getAssetUrl('favicon/favicon-32x32.png')}`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: `${getAssetUrl('favicon/favicon-16x16.png')}`,
  },
  {
    rel: 'manifest',
    href: `${getAssetUrl('favicon/manifest.json')}`,
  },
];
